export default __webpack_public_path__ + "static/media/Valerie-Geller.cce887ee.jpg";